import { NavBarLogic } from "./modules/navbar/navbar-logic";
import type { PlaygroundLogic } from "./modules/playground/playground-logic";

export class Logic {
  private _playgroundLogic?: PlaygroundLogic;
  private _navBarLogic?: NavBarLogic;

  playground() {
    if (!this._playgroundLogic) {
      throw new Error("Playground logic has not been initialized.");
    }
    return this._playgroundLogic;
  }

  initializePlayground(factory: () => PlaygroundLogic) {
    if (!this._playgroundLogic) {
      this._playgroundLogic = factory();
    }
    return this._playgroundLogic;
  }

  navBar() {
    if (!this._navBarLogic) {
      this._navBarLogic = new NavBarLogic(this);
    }
    return this._navBarLogic;
  }
}
